import { CARD_WIDTH } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/lib/constants'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { HEIGHT_MODIFIER_FOR_16_9_RATIO } from 'common/builder/components/chart/utils/constants'

const emptyMargin = 24

export const ImageEmpty = {
  ...sharedStyles.column,
  justifyContent: 'center',
  margin: `${emptyMargin}px`,
  height: (CARD_WIDTH - emptyMargin * 2) * HEIGHT_MODIFIER_FOR_16_9_RATIO,
}

export const ImageEmptySquare = {
  ...ImageEmpty,
  height: CARD_WIDTH - emptyMargin * 2,
}
